import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, tap } from 'rxjs';
import { combineLatestWith, map } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { WorkingTimeModalService } from './working-time-modal.service';
import { ConfigRepository } from 'src/app/shared/repositories/config.repository';
import { DeliveryType, Outlet, WorkingHours } from 'src/app/api/v1/models';
import { SessionRepository } from 'src/app/shared/repositories/session.repository';
import { zeroMaskFromTimeInterval } from 'src/app/shared/utils/get-time-intervals';
import { DAY_NAMES } from 'src/app/shared/data/day-names';

interface Schedule {
  dayKey: string,
  intervals: {
    open: string,
    close: string
  }[],
}

@Component({
  selector: 'app-working-time-modal',
  standalone: true,
  templateUrl: './working-time-modal.component.html',
  styleUrls: ['./working-time-modal.component.scss'],
  imports: [
    CommonModule,
    ModalComponent,
  ],
})
export class WorkingTimeModalComponent {
  constructor(
    private sessionRepository: SessionRepository,
    private workingTimeModalService: WorkingTimeModalService,
    private configRepository: ConfigRepository,
  ) { }

  isShowModal: boolean = false;
  dayNames: { [key: string]: string } = DAY_NAMES;

  address$ = this.configRepository.address$;

  showWorkingTimeModal$: Observable<unknown> = this.workingTimeModalService.showWorkingTimeModal$.pipe(
    tap(() => {
      this.isShowModal = true;
    })
  )

  schedule$ = this.configRepository.activeOutlet$.pipe(
    combineLatestWith(this.configRepository.deliveryAvailableIntervals$),
    map(([outlet, deliveryAvailableIntervals]) => this.getOutletSchedule(outlet, deliveryAvailableIntervals))
  );

  onClose() {
    this.isShowModal = false;
  }

  open() {
    this.isShowModal = true;
  }

  private getOutletSchedule(outlet: Outlet, deliveryAvailableIntervals: {[key: string]: WorkingHours[] } | null) {
    let schedule: Schedule[] = [];

    let intervals: {
      [key: string]: WorkingHours[];
    };

    if (this.sessionRepository.selectedDeliveryType === DeliveryType.Eatin) {
      intervals = outlet?.eatinIntervals;
    } else if (this.sessionRepository.selectedDeliveryType === DeliveryType.Pickup) {
      intervals = outlet?.pickupIntervals;
    } else {
      intervals = deliveryAvailableIntervals || {};
    }

    const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    weekDays.forEach(day => !!intervals[day] && schedule.push(
      {
        dayKey: day,
        intervals: intervals[day]?.map(i =>
        ({
          open: zeroMaskFromTimeInterval(i.open),
          close: zeroMaskFromTimeInterval(i.close)
        }))
      } as Schedule));

    return schedule;
  }
}
